<template>
  <div class="flex items-end gap-2 border-t bg-background p-3">
    <textarea
      ref="textareaRef"
      v-model="inputText"
      :placeholder="t('ai.inputPlaceholder')"
      :disabled="isStreaming"
      class="
        max-h-32 min-h-[40px] flex-1 resize-none rounded-md border bg-muted/50 px-3 py-2 text-sm
        focus:outline-none focus:ring-1 focus:ring-primary
      "
      rows="1"
      @keydown.enter.exact.prevent="handleSend"
      @input="autoResize"
    ></textarea>
    <Button
      v-if="isStreaming"
      variant="outline"
      size="icon"
      @click="$emit('stop')"
    >
      <Square class="size-4" />
    </Button>
    <Button
      v-else
      variant="default"
      size="icon"
      :disabled="!inputText.trim()"
      @click="handleSend"
    >
      <SendHorizontal class="size-4" />
    </Button>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { SendHorizontal, Square } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'

defineProps<{
  isStreaming: boolean
}>()

const emit = defineEmits<{
  send: [message: string]
  stop: []
}>()

const { t } = useI18n()
const inputText = ref('')
const textareaRef = ref<HTMLTextAreaElement>()

function handleSend() {
  if (!inputText.value.trim()) return
  emit('send', inputText.value.trim())
  inputText.value = ''
  nextTick(() => autoResize())
}

function autoResize() {
  const el = textareaRef.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = `${el.scrollHeight}px`
}

function focus() {
  textareaRef.value?.focus()
}

function setInputText(text: string) {
  inputText.value = text
  nextTick(() => {
    autoResize()
    focus()
  })
}

onMounted(() => focus())

defineExpose({ focus, setInputText })
</script>
